import SchedulerField from './SchedulerField';
import { FC } from 'react';

interface SMBFieldsProps {
    scheduler: {
        smbHost: string;
        smbSharedPath: string;
        smbShareDomain: string;
        smbUserName: string;
        smbUserPassword: string;
    };
    updateSchedulerField: (fieldName: string, value: string) => void;
}

const SMBFields: FC<SMBFieldsProps> = ({ scheduler, updateSchedulerField }) => {
    const { smbHost, smbSharedPath, smbShareDomain, smbUserName, smbUserPassword } = scheduler;
    return (
        <>
            <SchedulerField
                label={'Host'}
                placeholder={'Enter host'}
                value={smbHost}
                fieldName={'smbHost'}
                updateSchedulerField={updateSchedulerField}
            />
            <SchedulerField
                label="Local path"
                placeholder="Enter path"
                value={smbSharedPath}
                fieldName="smbSharedPath"
                updateSchedulerField={updateSchedulerField}
            />
            <SchedulerField
                label="Domain"
                placeholder="Enter domain"
                value={smbShareDomain}
                fieldName="smbShareDomain"
                updateSchedulerField={updateSchedulerField}
            />
            <SchedulerField
                label="User Name"
                placeholder="Enter user name"
                value={smbUserName}
                fieldName="smbUserName"
                updateSchedulerField={updateSchedulerField}
            />
            <SchedulerField
                label="User Password"
                placeholder="Enter user password"
                value={smbUserPassword}
                inputType="password"
                fieldName="smbUserPassword"
                updateSchedulerField={updateSchedulerField}
            />
        </>
    );
};

export default SMBFields;
